import EventEmitter from 'amkit3-modules/utils/stateful-events'
import cookie from 'amkit3-modules/utils/cookie'
import DanmuEvent from 'amkit3-modules/v/danmu/danmu-event'
import {
  DEFAULT_DANMU_POSITION,
  DEFAULT_DANMU_OPACITY,
  DEFAULT_DANMU_SIZE,
  DEFAULT_DANMU_TYPE,
  DANMU_TYPE_LIVE,
} from 'amkit3-modules/v/danmu/danmu-config'

import themeFactory from './themes/factory'

const MAX_COUNT = 100
const OPACITY_INNER_WIDTH = 206 - 6
const LIVE_DANMU_POP_STATUS = 'amkit3-player-danmu-pop'

class DanmuBar extends EventEmitter {
  constructor($, $container) {
    super()
    this.$ = $
    this.$container = $container
    this.style = themeFactory.getStyle()
    this.selector = themeFactory.getSelector()
    this.$danmuButton = this.$container.find(this.selector.danmuButton)
    this.$danmuInputValid = this.$container.find(this.selector.danmuInputValid)
    this.$danmuInputInvalid = this.$container.find(this.selector.danmuInputInvalid)
    this.$danmuInput = this.$container.find(this.selector.danmuInput)
    this.$danmuSubmit = this.$container.find(this.selector.danmuSubmit)
    this.$danmuInputRange = this.$container.find(this.selector.danmuInputRange)
    this.$danmuOpacityProgress = this.$container.find(this.selector.danmuSettingOpacityProgress)
    this.$danmuOpacityBar = this.$container.find(this.selector.danmuSettingOpacityBar)
    this.$danmuOpacityLoaded = this.$container.find(this.selector.danmuSettingOpacityLoaded)
    this.$danmuOpacityPercent = this.$container.find(this.selector.danmuSettingOpacityValue)

    this.$danmuOpacityLoaded.css('width', DEFAULT_DANMU_OPACITY + '%')
    this.$danmuOpacityPercent.text(DEFAULT_DANMU_OPACITY + '%')

    this.opacityLoaded = (OPACITY_INNER_WIDTH * DEFAULT_DANMU_OPACITY) / 100

    this.position = DEFAULT_DANMU_POSITION
    this.size = DEFAULT_DANMU_SIZE
    this.types = DEFAULT_DANMU_TYPE

    this.$(`${this.selector.danmuSettingPostionItem}[data-label=${this.position}]`).addClass(
      this.style.danmuSettingPostionItemActive,
    )
    this.$(`${this.selector.danmuSettingSizeItem}[data-label=${this.size}]`).addClass(
      this.style.danmuSettingSizeActive,
    )
    if (this.types) {
      let typeArr = this.types.split(',')
      typeArr.forEach(type => {
        if (!type) return
        this.$(`${this.selector.danmuSettingTypeItem}[data-label=${type}]`).addClass(
          this.style.danmuSettingTypeActive,
        )
      })
    }

    this.$container.on(
      'click',
      this.selector.danmuButton,
      this.statefulDelegate(() => {
        if (this.$danmuButton.hasClass(this.style.danmuButtonDisable)) {
          this.enableDanmu = true
          this.emit(DanmuEvent.ENABLE)
        } else {
          this.enableDanmu = false
          this.emit(DanmuEvent.DISABLE)
        }
        this.$danmuButton.toggleClass(this.style.danmuButtonDisable)
      }),
    )
    this.$container.on('click', this.selector.danmuInputInvalidSignUp, () =>
      this.emit(DanmuEvent.SIGNUP),
    )
    this.$container.on('click', this.selector.danmuInputInvalidSignIn, () =>
      this.emit(DanmuEvent.SIGNIN),
    )
    this.$container.on(
      'click',
      this.selector.danmuSubmit,
      this.statefulDelegate(() => {
        if (this.canSubmit) this.emit(DanmuEvent.SUBMIT)
      }),
    )
    // 隐藏提示现场弹幕pop
    this.$container.on(
      'click',
      this.selector.danmuSettingLivePopClose,
      this.statefulDelegate(() => {
        this.hideLiveDanmuPop()
      }),
    )

    this.$container.on(
      'click',
      this.selector.danmuSettingPostionItem,
      this.statefulDelegate(evt => {
        // evt.preventDefault();

        let $target = this.$(evt.currentTarget) || this.$(evt.target)
        let position = $target.attr('data-label')
        // console.log('danmuSettingPostionItem', $target, position)
        if (String(this.position) !== String(position)) {
          $target
            .addClass(this.style.danmuSettingPostionItemActive)
            .siblings()
            .removeClass(this.style.danmuSettingPostionItemActive)
          this.position = position
          this.emit(DanmuEvent.POSITION, position)
        }
      }),
    )

    this.$container.on(
      'click',
      this.selector.danmuSettingSizeItem,
      this.statefulDelegate(evt => {
        // evt.preventDefault();

        let $target = this.$(evt.currentTarget) || this.$(evt.target)
        let size = $target.attr('data-label')
        // console.log('danmuSettingSizeItem', $target, size)
        if (String(this.size) !== String(size)) {
          $target
            .addClass(this.style.danmuSettingSizeActive)
            .siblings()
            .removeClass(this.style.danmuSettingSizeActive)
          this.size = size
          this.emit(DanmuEvent.SIZE, size)
        }
      }),
    )

    this.$container.on(
      'click',
      this.selector.danmuSettingTypeItem,
      this.statefulDelegate(evt => {
        // evt.preventDefault();
        let $target = this.$(evt.currentTarget) || this.$(evt.target)
        let type = $target.attr('data-label')
        $target.toggleClass(this.style.danmuSettingTypeActive)
        let $actives = this.$container.find(this.selector.danmuSettingTypeActive)
        let types = []
        // 上报状态
        if (type === DANMU_TYPE_LIVE) {
          // console.log('danmu type change')
          this.emit(
            DanmuEvent.TYPE_CHANGE,
            JSON.stringify({ status: +$target.hasClass(this.style.danmuSettingTypeActive) }),
          )
        }
        $actives.each((index, item) => {
          const label = $(item).attr('data-label')
          types.push(label)
        })
        this.types = types.join()
        // if (this.types.indexOf(DANMU_TYPE_LIVE) >= 0) {
        //   this.hideLiveDanmuPop()
        // }
        this.emit(DanmuEvent.TYPE, this.types)
      }),
    )

    this.$danmuOpacityBar.on(
      'mousedown',
      this.statefulDelegate(evt => {
        this.isDown = true
        this.x1 = evt.pageX
        this.opacityLoaded = this.opacityLoaded || this.$danmuOpacityLoaded.clientWidth || 0
        // console.log('bar mousedown',this.$danmuOpacityLoaded, this.opacityLoaded )
        document.onmousemove = evt => {
          this.opacityMove(evt)
        }

        document.onmouseup = evt => {
          document.onmousemove = null
          document.onmouseup = null
          this.opacityEnd(evt)
        }
      }),
    )

    this.$danmuOpacityProgress.on(
      'click',
      this.statefulDelegate(evt => {
        this.isDown = true
        this.x1 = this.$danmuOpacityProgress.offset().left
        this.x2 = evt.pageX
        let duration = this.x2 - this.x1
        // console.log(this.x1, this.x2, duration)
        this.opacityPosition = Math.max(0, Math.min(OPACITY_INNER_WIDTH, duration))
        this.precent = (this.opacityPosition / OPACITY_INNER_WIDTH) * 100
        // console.log('opacityMove', this.precent)
        this.opacityLoaded = this.opacityPosition
        this.$danmuOpacityLoaded.css('width', this.precent + '%')
        this.$danmuOpacityPercent.text(parseInt(this.precent, 10) + '%')
        this.emit(DanmuEvent.OPACITY, this.precent)
        this.emit(DanmuEvent.OPACITY_END, this.precent)
      }),
    )

    this.$container.on(
      'keyup',
      this.selector.danmuInput,
      this.statefulDelegate(evt => {
        var length = this.$danmuInput.val().length

        if (length > MAX_COUNT) {
          this.$danmuInputRange.text(length + '/' + MAX_COUNT)
          this.$danmuInputValid.addClass(this.style.danmuInputValidOutOfRange)
        } else {
          this.$danmuInputRange.text('')
          this.$danmuInputValid.removeClass(this.style.danmuInputValidOutOfRange)
        }

        this.updateState()

        if (Number(evt.keyCode) === 13) {
          if (this.canSubmit) this.emit(DanmuEvent.SUBMIT)
        }
      }),
    )

    this.$container.on(
      'mouseenter',
      this.selector.danmuSetting,
      this.statefulDelegate(evt => {
        if (!cookie.get(LIVE_DANMU_POP_STATUS)) {
          this.hideLiveDanmuPop()
        }
      }),
    )
  }
  isEnable() {
    return this.enableDanmu
  }
  setDanmuValid(value) {
    if (value) {
      this.$danmuInputValid.css('display', 'inline-block')
      this.$danmuInputInvalid.hide()
    } else {
      this.$danmuInputValid.hide()
      this.$danmuInputInvalid.css('display', 'inline-block')
    }
  }
  submitCountdown() {
    this.$danmuInput.val('')
    clearInterval(this.countDownTId)
    var countDown = 5
    this.$danmuSubmit.text(countDown + '秒')
    this.countDownTId = setInterval(() => {
      countDown -= 1
      if (countDown > 0) {
        this.$danmuSubmit.text(countDown + '秒')
      } else {
        this.$danmuSubmit.text('发送')
        clearInterval(this.countDownTId)
        this.countDownTId = null
        this.updateState()
      }
    }, 1000)
    this.updateState()
  }
  updateState() {
    this.canSubmit =
      this.$danmuInput.val().length > 0 &&
      this.$danmuInput.val().length <= MAX_COUNT &&
      !this.countDownTId

    if (this.canSubmit) {
      this.$danmuSubmit.addClass(this.style.danmuSubmitAvailable)
    } else {
      this.$danmuSubmit.removeClass(this.style.danmuSubmitAvailable)
    }
  }

  opacityMove(evt) {
    if (!this.isDown) return
    this.x2 = evt.pageX
    let duration = this.x2 - this.x1
    this.opacityPosition = Math.max(0, Math.min(OPACITY_INNER_WIDTH, this.opacityLoaded + duration))
    this.precent = Math.max(5, (this.opacityPosition / OPACITY_INNER_WIDTH) * 100)
    this.$danmuOpacityLoaded.css('width', this.precent + '%')
    this.$danmuOpacityPercent.text(parseInt(this.precent, 10) + '%')
    this.emit(DanmuEvent.OPACITY, this.precent)
  }

  opacityEnd() {
    this.isDown = false
    this.opacityLoaded = this.opacityPosition
    this.emit(DanmuEvent.OPACITY_END, this.precent)
  }

  getDanmuContent() {
    return this.$danmuInput.val()
  }

  showDanmuType() {
    this.$danmuTypeWrapper = this.$container.find(this.selector.danmuSettingTypeWrapper)
    this.$danmuTypeWrapper.show()
  }
  // 线上提示现场弹幕pop
  showLiveDanmuPop() {
    const status = cookie.get(LIVE_DANMU_POP_STATUS) || '0'
    if (status == '1') return
    let $pop = this.$container.find(this.selector.danmuSettingLivePop)
    $pop.show()
  }
  // 隐藏提示现场弹幕pop
  hideLiveDanmuPop() {
    let $pop = this.$container.find(this.selector.danmuSettingLivePop)
    $pop.hide()

    // 设置弹幕弹窗关闭
    cookie.set(LIVE_DANMU_POP_STATUS, 1, {
      path: '/',
      expires: new Date(new Date().valueOf() + 10000 * 24 * 60 * 60 * 1000),
    })
  }

  enable() {
    super.enable()
    this.$danmuInput.prop('disabled', false)
  }
  disable() {
    super.disable()
    this.$danmuInput.prop('disabled', true)
  }
}

export default DanmuBar
